<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  withBorder: { type: Boolean, default: false },
  hideContent: { type: Boolean, default: false },
  beta: { type: Boolean, default: false },
});
const { t } = useI18n();
</script>

<template>
  <section
    class="mb-5 grid min-w-0 grid-cols-1 gap-4 rounded-lg border border-n-weak bg-n-surface-1 p-4 sm:p-5 [interpolate-size:allow-keywords]"
    :class="{
      'border-t border-n-weak': withBorder,
      'pb-4 sm:pb-5': !hideContent,
    }"
  >
    <header
      class="grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1fr)_auto]"
    >
      <div
        v-if="
          title || beta || $slots.title || description || $slots.description
        "
        class="min-w-0"
      >
        <h2
          v-if="title || beta || $slots.title"
          class="mb-0 flex flex-wrap items-center gap-2 text-sm font-semibold leading-6 text-n-slate-12"
        >
          <slot name="title">{{ title }}</slot>
          <div
            v-if="beta"
            v-tooltip.top="t('GENERAL.BETA_DESCRIPTION')"
            class="text-xs uppercase text-n-iris-11 border border-1 border-n-iris-10 leading-none rounded-lg px-1 py-0.5"
          >
            {{ t('GENERAL.BETA') }}
          </div>
        </h2>
        <p
          v-if="description || $slots.description"
          class="mb-0 mt-1 max-w-prose text-sm leading-6 text-n-slate-11"
        >
          <slot name="description">{{ description }}</slot>
        </p>
      </div>
      <div class="min-w-0">
        <slot name="headerActions" />
      </div>
    </header>
    <div
      class="min-w-0 transition-[height] duration-300 ease-in-out text-n-slate-12"
      :class="{ 'overflow-hidden h-0': hideContent, 'h-auto': !hideContent }"
    >
      <slot />
    </div>
  </section>
</template>
